<script setup lang="ts">
import { LawyerPage } from '@/pages/lawyer/index';

definePageMeta({ name: 'lawyer-detail-geo', scrollToTop: (to) => !to.hash });
</script>

<template>
  <LawyerPage />
</template>
